import { all, call, put, takeLatest } from 'redux-saga/effects'

import { api } from '../../services'

import {
  loadCompanyJobs,
  loadCompanyJobsFailure,
  loadCompanyJobsSuccess,
  setCompanyJobsFilter,
  initCompanyJobs
} from './actions'

export function * requestCompanyJobs ({ payload: { companyId, filter, page } }) {
  try {
    const { data: { items, hasMorePages } } = yield call(api.search.companyJobs, { companyId, filter, page })
    yield put(loadCompanyJobsSuccess({ items, page, hasMorePages }, { companyId }))
  } catch (e) {
    yield put(loadCompanyJobsFailure(e.message || e))
  }
}

export function * triggerLoadFromFilterChange ({ payload: { companyId, filter } }) {
  yield put(loadCompanyJobs({ companyId, filter }))
}

export function * initializeCompanyJobs ({ payload: { companyId } }) {
  yield put(loadCompanyJobs({ companyId }))
}

export default all([
  takeLatest(loadCompanyJobs, requestCompanyJobs),
  takeLatest(initCompanyJobs, initializeCompanyJobs),
  takeLatest(setCompanyJobsFilter, triggerLoadFromFilterChange)
])
